import { NoneFeasabilityResult } from "@/store/assessment.calc";
import { IAssessment } from "@/store/main.interfaces";
import { i18n } from "../main";

export const FEASIBILITY_MAP = {
  [NoneFeasabilityResult.POSTPONE]: "Zurückstellen",
  [NoneFeasabilityResult.DIGITIZE_FIRST]: "Erst Digitalisieren",
  [NoneFeasabilityResult.LOW_FEASIBILITY]: "Prozess ungeeignet"
};

enum VocalEaseOfImplementationSteps {
  LOW_EFFORT = 35,
  MEDIUM_EFFORT = 65,
  HIGH_EFFORT = 100
}
enum VocalBenefitSuitabilitySteps {
  LOW_BENEFIT = 10,
  MEDIUM_LOW_BENEFIT = 35,
  MEDIUM_HIGH_BENEFIT = 65,
  HIGH_BENEFIT = 100
}

export function vocalizeEaseOfImplementation(assessment: IAssessment) {
  const value: number | NoneFeasabilityResult =
    assessment.outputs.easeOfImplementation;
  if (typeof value === "number") {
    if (value <= VocalEaseOfImplementationSteps.LOW_EFFORT) {
      return i18n.t("generics.measurements.low");
    } else if (value <= VocalEaseOfImplementationSteps.MEDIUM_EFFORT) {
      return i18n.t("generics.measurements.medium");
    } else {
      return i18n.t("generics.measurements.high");
    }
  } else {
    return FEASIBILITY_MAP[value as NoneFeasabilityResult];
  }
}
export function vocalizeEaseOfImplementationAverage(value: number) {
  if (value <= VocalEaseOfImplementationSteps.LOW_EFFORT) {
    return i18n.t("generics.measurements.low");
  } else if (value <= VocalEaseOfImplementationSteps.MEDIUM_EFFORT) {
    return i18n.t("generics.measurements.medium");
  } else {
    return i18n.t("generics.measurements.high");
  }
}

export function vocalizeBenefitSuitability(assessment: IAssessment) {
  const value: number = assessment.outputs.benefitSuitability;
  const easeOfImplementation: number | NoneFeasabilityResult =
    assessment.outputs.easeOfImplementation;
  if (typeof easeOfImplementation !== "number") {
    return FEASIBILITY_MAP[NoneFeasabilityResult.LOW_FEASIBILITY];
  }
  if (value <= VocalBenefitSuitabilitySteps.LOW_BENEFIT) {
    return i18n.t("generics.measurements.low");
  } else if (value <= VocalBenefitSuitabilitySteps.MEDIUM_LOW_BENEFIT) {
    return i18n.t("generics.measurements.mediumLow");
  } else if (value <= VocalBenefitSuitabilitySteps.MEDIUM_HIGH_BENEFIT) {
    return i18n.t("generics.measurements.high");
  } else {
    return i18n.t("generics.measurements.veryHigh");
  }
}

export function vocalizeBenefitSuitabilityAverage(value: number) {
  if (value <= VocalBenefitSuitabilitySteps.LOW_BENEFIT) {
    return i18n.t("generics.measurements.low");
  } else if (value <= VocalBenefitSuitabilitySteps.MEDIUM_LOW_BENEFIT) {
    return i18n.t("generics.measurements.mediumLow");
  } else if (value <= VocalBenefitSuitabilitySteps.MEDIUM_HIGH_BENEFIT) {
    return i18n.t("generics.measurements.high");
  } else {
    return i18n.t("generics.measurements.veryHigh");
  }
}

export function vocalizeEffortToImplement(assessment: IAssessment) {
  const value: number | NoneFeasabilityResult =
    assessment.outputs.effortToImplement;
  if (typeof value === "number") {
    const min = Math.floor(value * 0.95);
    const max = Math.ceil(value * 1.05);
    return `${min} - ${max}h`;
  } else {
    return FEASIBILITY_MAP[value as NoneFeasabilityResult];
  }
}

export function vocalizeEffortToImplementAverage(value: number) {
  const min = Math.floor(value * 0.95);
  const max = Math.ceil(value * 1.05);
  return `${min} - ${max}h`;
}
